module.exports = __webpack_public_path__ + "img/2025-12-20c_2.8c2467e8.jpg";